import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  CardActionArea,
} from '@mui/material';
import {
  Facebook,
  WhatsApp,
  Campaign,
  SmartToy,
} from '@mui/icons-material';

const DashboardPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const features = [
    {
      title: t('facebookManager'),
      icon: <Facebook sx={{ fontSize: { xs: 50, sm: 60, md: 70 } }} />,
      gradient: 'linear-gradient(135deg, #1877F2 0%, #0D47A1 100%)',
      path: '/facebook',
    },
    {
      title: t('whatsappManager'),
      icon: <WhatsApp sx={{ fontSize: { xs: 50, sm: 60, md: 70 } }} />,
      gradient: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
      path: '/whatsapp',
    },
    {
      title: t('campaignManager'),
      icon: <Campaign sx={{ fontSize: { xs: 50, sm: 60, md: 70 } }} />,
      gradient: 'linear-gradient(135deg, #2196F3 0%, #1565C0 100%)',
      path: '/campaigns',
    },
    {
      title: t('chatbotManager'),
      icon: <SmartToy sx={{ fontSize: { xs: 50, sm: 60, md: 70 } }} />,
      gradient: 'linear-gradient(135deg, #42A5F5 0%, #1976D2 100%)',
      path: '/chatbot',
    },
  ];

  return (
    <Box>
      <Box
        sx={{
          mb: { xs: 3, sm: 4, md: 5 },
          textAlign: 'center',
          background: 'linear-gradient(135deg, #2196F3 0%, #1565C0 100%)',
          borderRadius: 3,
          p: { xs: 3, sm: 4, md: 5 },
          boxShadow: '0 8px 32px rgba(33, 150, 243, 0.4)',
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' },
            color: 'white',
          }}
        >
          {t('welcome')}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            mb: 1,
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            color: 'white',
          }}
        >
          {t('systemName')}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            opacity: 0.95,
            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' },
            color: 'white',
          }}
        >
          {t('systemDesc')}
        </Typography>
      </Box>

      <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={6} lg={3} key={index}>
            <Card
              sx={{
                background: '#0A0A0A',
                border: '2px solid rgba(33, 150, 243, 0.3)',
                borderRadius: 3,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: '0 12px 40px rgba(33, 150, 243, 0.5)',
                  border: '2px solid rgba(33, 150, 243, 0.6)',
                },
              }}
            >
              <CardActionArea onClick={() => navigate(feature.path)}>
                <CardContent
                  sx={{
                    textAlign: 'center',
                    p: { xs: 3, sm: 4 },
                  }}
                >
                  <Box
                    sx={{
                      background: feature.gradient,
                      borderRadius: '50%',
                      width: { xs: 80, sm: 100, md: 120 },
                      height: { xs: 80, sm: 100, md: 120 },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto',
                      mb: 3,
                      boxShadow: '0 8px 24px rgba(33, 150, 243, 0.4)',
                    }}
                  >
                    {React.cloneElement(feature.icon, { sx: { color: 'white', fontSize: { xs: 40, sm: 50, md: 60 } } })}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
                      color: 'primary.light',
                    }}
                  >
                    {feature.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DashboardPage;